<template>
  <div class="wrapper-jishen">
		<card class="card" v-if="enableHitScore">
      <div class="card-title">系统评分</div>

      <el-table :data="hitScoreRows">
        <el-table-column label="序号" prop="index" />
        <el-table-column label="规则名称" prop="ruleName" />
        <el-table-column label="规则权重" prop="hitScore">
          <template slot-scope="{ row }">
            <span class="danger-cell">{{ row.hitScore }}</span>
          </template>
        </el-table-column>
      </el-table>
    </card>

    <card class="card">
      <div class="card-title">重点关注</div>

      <div class="card-content">
        <el-row>
          <el-col
            v-for="(item, index) in keyAttentionRows"
            :key="index"
            :span="item.width ? item.width : 6"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </el-col>
        </el-row>
      </div>
    </card>

    <card class="card">
      <div class="card-title">法律诉讼</div>

      <div class="card-content">
        <el-row>
          <el-col
            v-for="(item, index) in involvementStatRows"
            :key="index"
            :span="item.width ? item.width : 6"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </el-col>
        </el-row>
      </div>

      <el-table :data="involvementRows" style="margin-top: 10px;">
        <el-table-column label="序号" prop="index" width="100" />
        <el-table-column label="日期" prop="caseTime" width="150" />
        <el-table-column label="类型" prop="dataType" width="150" />
        <el-table-column label="标题" prop="title" />
        <el-table-column label="内容摘要" prop="content" />
      </el-table>
    </card>

    <card class="card">
      <div class="card-title">贷款行为</div>

      <div>
        <AdminTitle title="优分汇总" size="15px" bottom="5px" />
        <div class="card-content">
          <el-row>
            <el-col
              v-for="(item, index) in yfSummaryRows"
              :key="index"
              :span="item.width ? item.width : 6"
            >
              <span class="label">{{ item.label }}：</span>
              <span class="value">{{ item.value }}</span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div style="margin-top: 20px;">
        <AdminTitle title="新颜汇总" size="15px" bottom="5px" />
        <div class="card-content">
          <el-row>
            <el-col
              v-for="(item, index) in xyStatRows"
              :key="index"
              :span="item.width ? item.width : 8"
            >
              <span class="label">{{ item.label }}：</span>
              <span class="value">{{ item.value }}</span>
            </el-col>
          </el-row>
        </div>

        <el-table :data="xyLoanRows" style="margin-top: 10px;">
          <el-table-column label="" prop="title" />
          <el-table-column label="近1个月" prop="m1" />
          <el-table-column label="近3个月" prop="m3" />
          <el-table-column label="近6个月" prop="m6" />
          <el-table-column label="近12个月" prop="m12" />
        </el-table>
      </div>
    </card>
  </div>
</template>

<script>
import { getOrderReviewDetailAPI } from "./api";

export default {
  name: "JiShen",

  data() {
    return {
      detail: {},
      enableHitScore: false,
      baiRong: {},
      youFen: {},
      xySpray: {},
      xyProbe: {},
      alipayRisk: {},
    };
  },

  computed: {
    member() {
      return this.detail.member || {};
    },

    finalLevel() {
      return this.detail.orderScoreProfile ? this.detail.orderScoreProfile.finalHitGrade : "";
    },

    scoreProfileData() {
      return this.detail.scoreProfileData || {};
    },

    hitScoreRows() {
      return (this.detail.hitScoreBillList ?? []).map((record, index) => {
        return {
          index: index + 1,
          ruleName: this.renderText(record.ruleName),
          hitScore: this.renderText(record.hitScore),
          hitSuggestDesc: this.renderText(record.hitSuggestDesc),
        };
      });
    },

    keyAttentionRows() {
      return [
        {
          label: "租安盾共租风险",
          value: this.renderText(this.alipayRisk?.zadMultiRisk || '-'),
        },
        {
          label: "当前逾期机构数",
          value: this.renderText(this.xyProbe?.currOverdueOrgNum || '-'),
        },
        {
          label: "黑名单等级",
          value: this.renderText(this.youFen?.blacklistLevel || '-'),
        },
        {
          label: "运营商在网时长",
          value: this.renderText(this.youFen?.netTime || '-'),
        },
        {
          label: "反欺诈评分",
          value: this.renderText(this.baiRong?.afRuleScore || '-'),
        },
        {
          label: "债偿压力指数",
          value: this.renderText(this.baiRong?.debtRepayStress || '-'),
        },
        {
          label: "综合风险",
          value: this.renderText(this.youFen?.riskCheck || '-'),
        },
        {
          label: "疑似养卡",
          value: this.renderText(this.youFen?.suspendCard || '-'),
        },
      ];
    },

    involvementStatRows() {
      return [
        {
          label: "个人涉诉总数",
          value: this.renderText(this.youFen?.personInvolvement?.count || '-'),
        },
        {
          label: "裁判文书",
          value: this.renderText(this.youFen?.personInvolvement?.judgeDocumentCount || '-'),
        },
        {
          label: "开庭公告",
          value: this.renderText(this.youFen?.personInvolvement?.openCourtNoticeCount || '-'),
        },
        {
          label: "执行公告",
          value: this.renderText(this.youFen?.personInvolvement?.executeNoticeCount || '-'),
        },
        {
          label: "失信公告",
          value: this.renderText(this.youFen?.personInvolvement?.dishonestyNoticeCount || '-'),
        },
        {
          label: "案件流程",
          value: this.renderText(this.youFen?.personInvolvement?.caseProduceCount || '-'),
        },
        {
          label: "曝光台",
          value: this.renderText(this.youFen?.personInvolvement?.exposureCount || '-'),
        },
      ];
    },

    involvementRows() {
      if (!this.youFen.personInvolvement || !this.youFen.personInvolvement.list) {
        return [];
      }
      return this.youFen.personInvolvement.list.map((row, index) => {
        return {
          index: index + 1,
          caseTime: this.renderText(row.caseTime),
          dataType: this.renderText(row.dataType),
          title: this.renderText(row.title),
          content: this.renderText(row.content),
        };
      });
    },

    yfSummaryRows() {
      return [
        {
          label: "申请机构总数",
          value: this.renderText(this.youFen?.applyOrgNum || '-'),
        },
        {
          label: "近12个月逾期次数",
          value: this.renderText(this.youFen?.m12OverdueNum || '-'),
        },
        {
          label: "近24个月逾期次数",
          value: this.renderText(this.youFen?.m24OverdueNum || '-'),
        },
        {
          label: "最近逾期距今天数",
          value: this.renderText(this.youFen?.overdueRecentlyDay || '-'),
        },
        {
          label: "最早逾期距今天数",
          value: this.renderText(this.youFen?.overdueHistoryDay || '-'),
        },
        {
          label: "逾期最大金额距今最近天数",
          value: this.renderText(this.youFen?.overdueMaxMoneyRecentlyDay || '-'),
        },
        {
          label: "逾期最大金额距今最早天数",
          value: this.renderText(this.youFen?.overdueMaxMoneyHistoryDay || '-'),
        },
      ];
    },

    xyStatRows() {
      return [
        {
          label: "申请命中机构数",
          value: this.renderText(this.xySpray?.applyHitOrgNum || '-'),
        },
        {
          label: "申请命中消金类机构数",
          value: this.renderText(this.xySpray?.applyHitConsumeLoanOrgNum || '-'),
        },
        {
          label: "申请命中网络贷款类机构数",
          value: this.renderText(this.xySpray?.applyHitNetLoanOrgNum || '-'),
        },
        {
          label: "机构总查询次数",
          value: this.renderText(this.xySpray?.totalOrgQueryNum || '-'),
        },
        {
          label: "最近一次查询时间",
          value: this.renderText(this.xySpray?.lastOrgQueryTime || '-'),
        },
        {
          label: "正常还款订单比例",
          value: this.renderText(this.xySpray?.normalRepayOrderRate || '-'),
        },
      ];
    },

    xyLoanRows() {
      return [
        {
          title: '申请历史',
          m1: this.renderText(this.xySpray?.m1OrgQueryNum || '-'),
          m3: this.renderText(this.xySpray?.m3OrgQueryNum || '-'),
          m6: this.renderText(this.xySpray?.m6OrgQueryNum || '-'),
          m12: '-',
        },
        {
          title: '贷款笔数',
          m1: this.renderText(this.xySpray?.m1LoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3LoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6LoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12LoanNum || '-'),
        },
        {
          title: '贷款金额',
          m1: this.renderText(this.xySpray?.m1LoanAmount || '-'),
          m3: this.renderText(this.xySpray?.m3LoanAmount || '-'),
          m6: this.renderText(this.xySpray?.m6LoanAmount || '-'),
          m12: this.renderText(this.xySpray?.m12LoanAmount || '-'),
        },
        {
          title: '贷款机构数',
          m1: this.renderText(this.xySpray?.m1LoanOrgNum || '-'),
          m3: this.renderText(this.xySpray?.m3LoanOrgNum || '-'),
          m6: this.renderText(this.xySpray?.m6LoanOrgNum || '-'),
          m12: this.renderText(this.xySpray?.m12LoanOrgNum || '-'),
        },
        {
          title: 'M0+逾期笔数',
          m1: this.renderText(this.xySpray?.m1M0OverdueLoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3M0OverdueLoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6M0OverdueLoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12M0OverdueLoanNum || '-'),
        },
        {
          title: 'M1+逾期笔数',
          m1: this.renderText(this.xySpray?.m1M1OverdueLoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3M1OverdueLoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6M1OverdueLoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12M1OverdueLoanNum || '-'),
        },
        {
          title: '逾期金额',
          m1: this.renderText(this.xySpray?.m1TotalOverdueAmount || '-'),
          m3: this.renderText(this.xySpray?.m3TotalOverdueAmount || '-'),
          m6: this.renderText(this.xySpray?.m6TotalOverdueAmount || '-'),
          m12: this.renderText(this.xySpray?.m12TotalOverdueAmount || '-'),
        },
        {
          title: '扣款失败笔数',
          m1: this.renderText(this.xySpray?.m1FailDeductNum || '-'),
          m3: this.renderText(this.xySpray?.m3FailDeductNum || '-'),
          m6: this.renderText(this.xySpray?.m6FailDeductNum || '-'),
          m12: this.renderText(this.xySpray?.m12FailDeductNum || '-'),
        },
      ];
    },

    brApplyRecord() {
      return [
        {
          title: "线上消费分期的次数",
          d7: this.renderText(this.baiRong.d7CoonAllNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "线上消费分期的机构数",
          d7: this.renderText(this.baiRong.d7CoonOrgNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌小贷机构申请次数",
          d7: this.renderText(this.baiRong.d7NbankSloanAllNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌小贷机构申请机构数",
          d7: this.renderText(this.baiRong.d7NbankSloanOrgNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌融资租赁机构申请次数",
          d7: "-",
          d15: this.renderText(this.baiRong.d15NbankFinleaAllNum),
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "非银机构周末申请机构数",
          d7: "-",
          d15: this.renderText(this.baiRong.d15NbankWeekOrgNum),
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "非银机构申请次数",
          d7: "-",
          d15: "-",
          m1: this.renderText(this.baiRong.m1IdNbankAllNum),
          m3: this.renderText(this.baiRong.m3IdNbankAllNum),
          m6: this.renderText(this.baiRong.m6NbankAllNum),
        },
        {
          title: "申请汽车金融的机构数",
          d7: "-",
          d15: "-",
          m1: this.renderText(this.baiRong.m1AfOrgNum),
        },
        {
          title: "非银机构-其他申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6NbankOthAllNum),
        },
        {
          title: "非银机构-消费类分期机构申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6NbankCfAllNum),
        },
        {
          title: "按身份证号查询在非银机构申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6IdNbankAllNum),
        },
      ];
    },
  },

  mounted() {
    this.enableHitScore = this.$route.query.orderType == 2 || this.$route.query.orderType == 4;
    this.getRiskReview();
  },

  methods: {
    renderText(value) {
      return value ?? "-";
    },

    async getRiskReview() {
      const res = await getOrderReviewDetailAPI(this.$route.params.id);
      this.detail = res;
      this.baiRong = res.baiRong;
      this.youFen = res.youFen;
      this.xySpray = res.xySpray
      this.xyProbe = res.xyProbe;
      this.alipayRisk = res.alipayRisk;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-jishen {
  width: 100%;
}

.card {
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  
  ::v-deep .el-card__body {
    padding: 24px;
  }
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 18px;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    border-radius: 2px;
  }
}

.danger-cell {
  color: #f56c6c;
  font-weight: 600;
}

.without-layout .wrapper-jishen ::v-deep {
  overflow-y: auto;
  margin-top: 0;

  .table-svg-header {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .el-table {
    border-radius: 8px;
    overflow: hidden;
    
    .el-table__header {
      .el-table__cell {
        font-weight: 600;
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
      }
    }
    
    .el-table__body {
      tr {
        transition: all 0.25s ease;
        
        &:hover {
          background: #f5f7fa;
        }
      }
    }
  }

  .performance-records-table tbody tr:not(:last-child) td {
    &:first-child {
      background: #faeeee;
    }
    color: #d05252;
  }
}

.card-content {
  line-height: 36px;
  padding: 12px 0;

  .label {
    display: inline-block;
    min-width: 140px;
    text-align: right;
    color: #606266;
    font-weight: 500;
    margin-right: 12px;
  }

  .value {
    font-weight: 600;
    color: #303133;
  }
  
  .el-row {
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.online-summary {
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  margin-bottom: 20px;

  .online-summary-item {
    width: calc(50% - 8px);
    background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
    border-radius: 10px;
    padding: 20px;
    border: 1px solid #e4e7ed;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    .online-summary-item-header {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 16px;
      color: #303133;
      display: flex;
      align-items: center;
      gap: 8px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e4e7ed;
    }

    .online-summary-item-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      padding: 4px 0;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      & > span:first-child {
        color: #606266;
        font-size: 14px;
      }

      & > span:last-child {
        color: #303133;
        font-weight: 600;
        font-size: 14px;
      }

      &.danger-row span {
        color: #f56c6c !important;
      }
    }
  }
}

// 表格样式优化
::v-deep .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #EBEEF5;
  
  .el-table__header {
    th {
      background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
      color: #303133;
      font-weight: 600;
      font-size: 13px;
      border-bottom: 2px solid #E4E7ED;
    }
  }
  
  .el-table__body {
    tr {
      transition: all 0.25s ease;
      
      &:hover {
        background: #f5f7fa;
      }
      
      td {
        border-bottom: 1px solid #F0F2F5;
        color: #606266;
        font-size: 13px;
      }
    }
  }
}
</style>
